import React from "react";
import BlogThirtyTwo from "../component/BlogThirtyTwo";

function BlogThirtyTwoContainer() {
  return <BlogThirtyTwo />;
}
export default BlogThirtyTwoContainer;
